<template>
  <div class="page-container" style="min-height: 700px;">
    <div class="page-title-container">
      <h1 class="title-text">Work with us</h1>
    </div>

    <div class="features-container">
      <div class="display-our-job-offer">
        <p><b>Lead Recruiter</b> Remote - $80,000/year</p>
        <button type="button" class="primary-button small-button">Apply</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
